import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        optionsWrapper: {
            display: 'flex',
            alignItems: 'center',
        },

        option: {
            cursor: 'pointer',
            padding: theme.spacing(0.625),
            width: 40,
            textAlign: 'center',
            transition: 'background-color 03:s',
            '&:hover': {
                backgroundColor: theme.palette.secondary[100],
            },
        },
        selectedOption: {
            backgroundColor: `${theme.palette.secondary[100]} !important`,
        },
        datePicker: {
            marginLeft: theme.spacing(0.625),
            marginRight: theme.spacing(0.625),
        },
    }
})

export default useStyles
